import { container } from 'tsyringe';

import { AuthServiceImpl } from '@/v1/main/usecases';
import { LoginForm } from '@/v1/main/views/Form';

import styles from './Login.module.scss';

export const Login: React.FC = () => {
    const usecase = container.resolve(AuthServiceImpl);
    return (
        <div className={styles.wrapper}>
            <LoginForm usecase={usecase} />
        </div>
    );
};
